import { Box } from "@chakra-ui/react";
import React from "react";

const CustomBadge = ({
  children,
  color = "white",
  bg = "blue.500",
  fontSize = "sm",
  fontWeight = "semibold",
  px = 2,
  py = 1,
  borderRadius = "md",
  variant = "solid", // solid | subtle | outline
  style,
  ...rest
}) => {
  let styles = {
    solid: {
      bg,
      color,
    },
    subtle: {
      bg: `${bg}`, // lighter background
      color: bg,
    },
    outline: {
      bg: "transparent",
      border: "1px solid",
      borderColor: bg,
      color: bg,
    },
  };

  return (
    <Box
      display="inline-block"
      px={px}
      py={py}
      borderRadius={borderRadius}
      fontSize={fontSize}
      fontWeight={fontWeight}
      textTransform="capitalize"
      {...styles[variant]}
      style={style}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default CustomBadge;
